<template>
  <div>

    <overview :center_execute_id="center_execute_id" :center_execute_candidate_id="center_execute_candidate_id"
      @changeNextPrev="changeNextPrev">
    </overview>
  </div>
</template>

<script>
  import overview from "./overview";
  export default {
    name: "overview-page",
    components: {
      overview
    },
    data() {
      return {
        center_execute_id: this.$route.params.center_execute_id,
        center_execute_candidate_id: this.$route.params.center_execute_candidate_id.toString()
      };
    },
    methods: {
      changeNextPrev(id) {
        this.$router.push({
          name: "editWashUp",
          params: {
            "center_execute_candidate_id": id,
            "center_execute_id": this.center_execute_id
          }
        })
      },
    }
  };

</script>

<style>
</style>
